import React from "react";
import { useState } from "react";
import NextGuide from "@/components/atomics/nextGuide";
import FirstGuide from "@/components/atomics/firstGuide";

interface GuideProps {
  guideData: any;
  onClose?: () => void;
}

const Guide = ({ guideData, onClose }: GuideProps) => {
  const [showNextGuide, setShowNextGuide] = useState(false);

  const handleCancel = () => {
    onClose?.();
  };

  const handleGuideClick = () => {
    setShowNextGuide(true);
  };

  const handleFinish = () => {
    onClose?.();
  };

  return (
    <div className="bg-black">
      {!showNextGuide ? (
        <FirstGuide
          title={guideData[0].title}
          popupTitle={guideData[0]?.popupTitle || ""}
          subTitle={guideData[0]?.subTitle || ""}
          content={guideData[0]?.subContent || ""}
          cancelClick={handleCancel}
          guideClick={handleGuideClick}
        />
      ) : (
        <NextGuide
          title={guideData[1].title}
          data={guideData[1]?.data || []}
          onFinish={handleFinish}
          onCancelClick={handleCancel}
        />
      )}
    </div>
  );
};

export default Guide;
